import React, { useEffect } from "react";
import cx from "classnames";
import { Element as ScrollElement } from "react-scroll";
import { Link } from "gatsby";
import { Image } from "src/components/image";
import { Container } from "src/components/container";

import * as styles from "./gallery.module.css";

interface GalleryItem {
	_key: string;
	type: string;
	copy?: any;
	image?: any;
}

interface GalleryProps {
	data: {
		title: string;
		tags: {
			tags: any[];
		};
		gallery: [
			{
				items: GalleryItem[];
			}
		];
	};
}

export const ProjectGallery = ({ data }: GalleryProps) => {
	const { gallery, title, tags } = data;
	return (
		<div className={styles.gallery}>
			<h1 className={cx("ac headline", styles.title)}>{title}</h1>
			<div className={styles.grid}>
				{gallery &&
					gallery.map((section: any) => (
						<div
							key={section._key}
							className={cx(
								"",
								styles.row,
								styles[`layout${section.items.length}Across`]
							)}
						>
							{section.items.map((item: GalleryItem) => (
								<ScrollElement
									key={item._key}
									name={`${item._key}`}
									className={styles.column}
								>
									<div className={styles.imageContainer}>
										{item.image?.asset?._ref && (
											<Image
												className={styles.image}
												gatsbyImageClassName={styles.gatsbyImage}
												alt={item.image.alt || title}
												imageId={item.image.asset._ref}
											/>
										)}
									</div>
								</ScrollElement>
							))}
						</div>
					))}
			</div>
			{tags && (
				<div className={styles.tags}>
					<span className="label">Tags: </span>
					{tags &&
						tags.tags.map((tag, index) => (
							<Link key={tag._id} to={`/work/tagged/${tag.slug.current}`}>
								<span className="label">
									{index > 0 && <span>, </span>}
									<span className="underline-on-hover">{tag.title}</span>
								</span>
							</Link>
						))}
				</div>
			)}
		</div>
	);
};

// ProjectCard.whyDidYouRender = true;
